<div class="verify-container">
    <div class="verify-card">
        <div *ngIf="isLoading" class="verify-header">
            <h1>Vérification d'Email</h1>
            <p>Validation de votre compte Farco</p>
        </div>

        <div class="verify-content">
            <!-- Loading State -->
            <div *ngIf="isLoading" class="loading-state">
                <div class="spinner"></div>
                <p>Vérification de votre email en cours...</p>
            </div>

            <!-- Success State -->
            <div *ngIf="isSuccess && !isLoading" class="success-state">
                <h2>Email Vérifié avec Succès!</h2>
                <p>Votre adresse email a été vérifiée avec succès. Vous pouvez maintenant vous connecter à votre compte.</p>
                <p class="redirect-message">Redirection automatique vers la page de connexion dans 3 secondes...</p>
                <div class="action-buttons">
                    <button class="btn-primary" (click)="router.navigate(['/login'])">
                        Se connecter maintenant
                    </button>
                </div>
            </div>

            <!-- Error State -->
            <div *ngIf="!isSuccess && !isLoading" class="error-state">
                <h2>Échec de la Vérification</h2>
                <p>{{ errorMessage }}</p>
                <div class="action-buttons">
                    <button class="btn-primary" (click)="navigateToResend()">
                        Renvoyer le lien de vérification
                    </button>
                    <button class="btn-secondary" (click)="navigateToLogin()">
                        Retour à la connexion
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>